/**
 * System Configuration
 * Manages all routing and testing parameters
 */
window.SYSTEM_CONFIG = {
  // Domain-wide cookie scope
  PRIMARY_HOST: "primathontech.co.in",
  FIRST_ALTERNATE: "kilrr-qa-shopify.primathontech.co.in",
  SECOND_ALTERNATE: "wellversed-dev-shopify.primathontech.co.in",
  COOKIE_SCOPE: ".kilrr.com",

  // Traffic distribution percentages
  SPLIT_TO_FIRST: 33,   // % to first alternate domain
  SPLIT_TO_SECOND: 33,  // % to second alternate domain
  // Remaining % automatically goes to primary domain
  
  // A/B Test Feature Toggles
  TOGGLE_HOME_TEST: true,
  TOGGLE_PRODUCT_TEST: true,
  TOGGLE_LISTING_TEST: true,
  
  // A/B Test Split Percentages (0.0001 to 100)
  HOME_TEST_SPLIT: 100,     // % of users seeing variant B
  PRODUCT_TEST_SPLIT: 100,  // % of users seeing variant B
  LISTING_TEST_SPLIT: 100,  // % of users seeing variant B
  
  // Configuration version - increment to invalidate all sessions
  CONFIG_VERSION: 6
};